.section {
  margin-top: var(--tuna-spacing-3);
}

.title {
  margin-bottom: 4px;
}

.intro {
  margin-bottom: var(--tuna-spacing-1);
}

.list {
  list-style: none;
  margin: 0 0 var(--tuna-spacing-1);
  padding: 0;
  border-top: 1px solid var(--tuna-border-subtle);
}

.row {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-1);
  border-bottom: 1px solid var(--tuna-border-subtle);
}

.summary {
  flex: 1;
  min-width: 0;
  min-height: 44px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 2px;
  padding: var(--tuna-spacing-1) 0;
  border: 0;
  background: none;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.summary:focus-visible {
  outline: 2px solid var(--tuna-focus-ring);
  outline-offset: 2px;
}

.primary {
  font-size: var(--tuna-typography-body1-fontSize);
  color: var(--tuna-content-primary);
}

.secondary {
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-secondary);
}

.editing {
  border-bottom: 1px solid var(--tuna-border-subtle);
  padding: var(--tuna-spacing-2) 0;
}

.form {
  display: grid;
  gap: var(--tuna-spacing-2);
  max-width: 560px;
}

.formActions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: var(--tuna-spacing-1);
}
